// extracted by mini-css-extract-plugin
module.exports = {"container":"videoTestimonialCardV2_container__Yaf2F","videoItem":"videoTestimonialCardV2_videoItem__N75g6"};